import { pxToRem } from "@ottatech/design";
import styled from "styled-components";

export const FooterContent = styled.div<{ align?: "center" }>`
  margin: 0 auto;
  max-width: ${pxToRem(490)};
  text-align: ${({ align = "inherit" }) => align};
`;
